export default __webpack_public_path__ + "static/media/Íconos 02.f707ea8c.png";